module.exports = __webpack_public_path__ + "img/top.4883112e.png";